export default function Chart(props) {
  return (
    <svg width='73.281' height='66.641' viewBox='0 0 73.281 66.641' {...props}>
      <path
        id='e915'
        d='M70,0H56.641a3.356,3.356,0,0,0-2.422.9,3.148,3.148,0,0,0-.937,2.383v60a3.248,3.248,0,0,0,.938,2.461,3.356,3.356,0,0,0,2.422.9H70a3.221,3.221,0,0,0,2.383-.9,3.325,3.325,0,0,0,.9-2.461v-60A3.221,3.221,0,0,0,72.383.9,3.221,3.221,0,0,0,70,0ZM66.641,60H60V6.641h6.641ZM43.281,16.641H30A3.106,3.106,0,0,0,26.641,20V63.281A3.106,3.106,0,0,0,30,66.641H43.281a3.106,3.106,0,0,0,3.359-3.359V20a3.106,3.106,0,0,0-3.359-3.359ZM40,60H33.281V23.281H40ZM16.641,33.281H3.281A3.148,3.148,0,0,0,.9,34.219,3.356,3.356,0,0,0,0,36.641V63.281a3.325,3.325,0,0,0,.9,2.461,3.221,3.221,0,0,0,2.383.9H16.641a3.356,3.356,0,0,0,2.422-.9A3.248,3.248,0,0,0,20,63.281V36.641a3.213,3.213,0,0,0-3.359-3.359ZM13.281,60H6.641V40h6.641Z'
        fill='#0e77ef'
      />
    </svg>
  )
}
